module.exports = __webpack_public_path__ + "img/7_35.eb83e4bc.png";